
import ButtonAddToCart from '~/components/product/ButtonAddToCart';

export default {
  name: 'Information',

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    productSku: function () {
      return '';
      return this.$productSku(this.product);
    },
    productBrand: function () {
      return this.product?.brand?.name || '';
    },
    productQuantity: function () {
      return this.product?.quantity || 0;
    },
    productPriceCount: function () {
      return (this.product?.price || 0) * 4;
    },
    productPriceOld: function () {
      if (this.product?.oldPrice || this.product?.oldPrice >= this.product.price) {

        return this.product?.oldPrice;
      }
      return;
    },
    productQuantityUnit: function () {
      return (this.product?.unit || '').replace('/', '');
    },
    productPresence: function () {
      const characteristics = [];
      (this.product?.characteristics || []).map((t) => {
        characteristics.push(...(t?.characteristics || []));
      });

      const nalicieTovara = (characteristics || []).find((t) => t.slug === 'nalicie-tovara')?.values?.[0];
      if (nalicieTovara) {
        return nalicieTovara?.value;
      }

      return 'Уточнить';
    },

    isAvaibleCountProduct: function () {
      return Boolean((this.product?.quantity || 0) > 0 && !this.product.isNotAvailable && this.product.price>0);
    },
    isVisiblePriceForCount: function () {
      const notAvaible = JSON.parse(this.$store.state.appState?.vars?.['Типы товаров у которых скрывать цену за 4шт'] || '[]');
      if (notAvaible.includes(this.product.characteristicGroupId)) {
        return false;
      }

      if ((this.product?.quantity || 0) < 4) {
        return false;
      }

      return true;
    },
    isProductPriceGray: function () {
      if (!!this.productQuantityUnit && this.productQuantityUnit !== 'шт') {
        return false;
      }

      return (this.product?.quantity || 0) < 4;
    },

    characteristicsMain: function () {
      const slugsLink = ['width', 'height', 'diameter', 'season', 'spikes', 'pcd-boltcount'];
      const slugsHidden = ['nalicie-tovara'];
      const catalogFilterLink = [(this.product?.categories || []).map((t) => t.slug)?.join('/'), 'f'];
      let lpo = `/${catalogFilterLink[0]}/f`;
      let lpo0 = `/${catalogFilterLink[0]}/f`;

      let characteristics = (this.product?.characteristics || []).find((t) => t?.name === 'Основные')?.characteristics || [];
      characteristics = characteristics.filter((t) => t.showInProduct);
      characteristics = characteristics.filter((t) => !slugsHidden.includes(t.slug));
      characteristics = characteristics.map((characteristic) => {
        const item = {
          ...characteristic,
          values: (characteristic?.values || []).map((t) => ({
            ...t,
            value: [t.value, characteristic.unit].filter((t) => !!t).join(' '),
          })),
        };
        if (item.slug === 'tiporazmer') {
          item.itemprop = 'model';

          const variantFilterSlug = [
            Boolean(characteristics.find((t) => t.slug === 'width')) && `width=${characteristics.find((t) => t.slug === 'width')?.values?.[0]?.slug}`,
            Boolean(characteristics.find((t) => t.slug === 'height')) && `height=${characteristics.find((t) => t.slug === 'height')?.values?.[0]?.slug}`,
            Boolean(characteristics.find((t) => t.slug === 'diameter')) && `diameter=${characteristics.find((t) => t.slug === 'diameter')?.values?.[0]?.slug}`,
          ].filter((t) => !!t).join('/');
          item.link = `/${[...catalogFilterLink, variantFilterSlug].join('/')}`;
        }
        if (slugsLink.includes(item.slug)) {
          item.link = `/${[...catalogFilterLink, `${item.slug}=${item?.values?.[0]?.slug}`].join('/')}`;
          lpo = `${[lpo, `${item.slug}=${item?.values?.[0]?.slug}`].join('/')}`;
        }
        return item;
      });

      characteristics['lpo'] = lpo;
      if (lpo === lpo0){
        characteristics['lpo0'] = '0';
      }
      return characteristics;
    },
    messageAddendumAboutPackage: function () {
      // Для БУ выводить сообщение о продаже только комплектом
      if (([12, 13].includes(this.product.characteristicGroupId))
        && ((this.productQuantityUnit || '').indexOf('комплект') > -1)) {
        return 'Продается только комплектом';
      }
      return '';
    },

    cartQuantity: function () {
      const items = this.$store.state?.cart?.items || [];
      const cartItem = items.find((t) => t?.product?.id === this.product?.id);
      return cartItem?.quantity || 0;
    },

    collectionLink: function () {
      return this.product?.productSetParents?.[0]?.url || '';
    },
  },

  components: {
    ButtonAddToCart,
  },

  mounted: function () {
    this.$yandexCommerce('detail', [{
      ...this.product,
      quantity: 1,
    }]);
  },

  methods: {
    addToCart: async function () {
      const productItemCart = {
        productId: this.product.id,
        quantity: 1,
      };
      const res = await this.$store.dispatch('cart-custom/putToCart', productItemCart);
      if (!res.isSuccess) {
        this.$toast.error(res.errorMessage);
        return;
      }

      this.$toast.success('Товар добавлен в корзину');
      this.$yandexMetrika.reachGoal('add_to_cart_product_page');
      this.$yandexCommerce('add', [{
        ...this.product,
        quantity: 1,
      }]);

      await this.$store.dispatch('cart/getCart');
    },
    orderOneClick: function () {
      this.$store.commit('fast-buy/open', this.product);
    },
    notifyAboutArrival: async function () {
      this.$store.commit('pop-up-back-call/open', {
        type: 'Сообщить о поступлении товара',
        title: 'Сообщить о поступлении',
      });
    },
  },
};
